import { createClient } from '@sanity/client'
import type { ClientConfig } from '@sanity/client'
import env from '@/constants/env'

const previewParams: Partial<ClientConfig> = {
  useCdn: false,
  perspective: 'previewDrafts',
}

const productionParams: Partial<ClientConfig> = {
  useCdn: true,
  perspective: 'published',
}

export default createClient({
  projectId: env.PUBLIC_SANITY_PROJECT_ID,
  dataset: env.PUBLIC_SANITY_DATASET,
  apiVersion: '2023-07-20',
  token: env.PUBLIC_SANITY_CLIENT_TOKEN,
  ...(env.PUBLIC_SANITY_PREVIEW === 'true' ? previewParams : productionParams),
})
